module.exports = __webpack_public_path__ + "img/course108_curriculum.35b8d2d5.png";